export default {
    getNotif: (state: any): any => state.notif,
    getTotal: (state: any): any => state.total,
};